'use client'

import {
	CommonGenericEvents,
	SECTION_PARAMETERS_MY_ACCOUNT,
} from 'account-actions/constants/analytics'
import { sendGenericEvent } from 'analytics/events/generics/sendGenericEvent'
import { createContext, useMemo, useState } from 'react'

type AccountMenuContextType = {
	isOpen: boolean
	open: () => void
	close: () => void
}

export const AccountMenuContext = createContext<AccountMenuContextType | null>(
	null
)

export function AccountMenuProvider({
	children,
}: {
	readonly children: React.ReactNode
}) {
	const [isOpen, setIsOpen] = useState(false)

	const open = () => {
		if (!isOpen) {
			sendGenericEvent(CommonGenericEvents.DISPLAY_HEADER, {
				section: SECTION_PARAMETERS_MY_ACCOUNT,
			})
		}

		setIsOpen(true)
	}

	const close = () => {
		setIsOpen(false)
	}

	const value = useMemo(() => ({ isOpen, open, close }), [isOpen, open, close])

	return (
		<AccountMenuContext.Provider value={value}>
			{children}
		</AccountMenuContext.Provider>
	)
}
